import { WorklistStatusIndicator } from '@strata/react-status-indicators';
import { isTaskTodo } from '@strata/react-worklist';

import { getWorklistTasks, getWorklistToDoTaskCount } from 'api/worklistAPI';
import { handleError } from 'services/Error';
import { AppThunk } from 'store';
import {
    setWorklistTasks,
    setWorklistTaskStatus,
    setWorklistToDoTaskCount,
} from 'store/worklist/worklistSlice';

export const fetchWorklistToDoTaskCount = (): AppThunk => async (dispatch) => {
    try {
        const response = await getWorklistToDoTaskCount();
        dispatch(setWorklistToDoTaskCount(response.task_count));
    } catch (err) {
        handleError('An error occurred retrieving worklist task count.', err as Error);
    }
};

export const fetchWorklistTasks = (): AppThunk<Promise<void>> => async (dispatch) => {
    try {
        const response = await getWorklistTasks();

        dispatch(setWorklistTasks(response ?? undefined));

        // Update the to-do task count to match the fetched tasks
        dispatch(
            setWorklistToDoTaskCount((response ?? []).filter((task) => isTaskTodo(task)).length),
        );
    } catch (err) {
        handleError('An error occurred retrieving worklist.', err as Error);
        dispatch(setWorklistTasks([]));
    }
};

export const completeWorklistTask =
    (taskId: string): AppThunk =>
    (dispatch) => {
        dispatch(
            setWorklistTaskStatus({ taskId, status: WorklistStatusIndicator.Statuses.COMPLETED }),
        );
    };
